<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.area_name')">
        <b-input v-model="catalog.area_name" disabled expanded></b-input>
      </b-field>
      <b-field horizontal :label="$t('attributes.catalog_code')">
        <b-input v-model="catalog.catalog_no" disabled expanded></b-input>
      </b-field>

      <form-wrapper :validator="$v.form">
        <form-group horizontal name="name" :label="$t('attributes.name')">
          <b-input
            v-model="form.name"
            name="name"
            :placeholder="$t('message.please_input') + $t('attributes.name')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="description"
          :label="$t('attributes.description')"
        >
          <b-input
            v-model="form.description"
            type="textarea"
            name="description"
            :placeholder="
              $t('message.please_input') + $t('attributes.description')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="email"
          :label="$t('attributes.order_email')"
        >
          <b-input
            v-model="form.email"
            name="email"
            :placeholder="$t('message.please_input') + $t('attributes.email')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="link"
          attribute="attributes.external_url"
          :label="$t('attributes.external_url')"
        >
          <b-input
            v-model="form.link"
            name="link"
            :placeholder="
              $t('message.please_input') + $t('attributes.external_url')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="status"
          attribute="attributes.status"
          :label="$t('attributes.status')"
        >
          <b-switch v-model="form.status" name="status"></b-switch>
        </form-group>

        <form-group horizontal name="sort" :label="$t('attributes.sort')">
          <b-select v-model="form.sort" name="sort">
            <option v-for="option in sortOptions" :key="option" :value="option">
              {{ option }}
            </option>
          </b-select>
        </form-group>
        <form-group
          horizontal
          name="regionList"
          :label="$t('attributes.group')"
        >
          <b-select v-model="form.region_list_no" name="regionList">
            <option value="" style="color: #D0D0D0;">無群組</option>
            <option
              v-for="option in regionList"
              :value="option.region_list_no"
              :key="option.region_list_no"
            >
              {{
                option.region_list_status === 'Y'
                  ? option.region_list_name
                  : option.region_list_name + '(下架)'
              }}
            </option>
          </b-select>
        </form-group>

        <form-group
          horizontal
          name="is_home"
          :label="$t('attributes.catalog_is_home')"
        >
          <b-select v-model="form.is_home" name="is_home">
            <option value="true">{{ $t('attributes.display') }}</option>
            <option value="false">{{ $t('attributes.hide') }}</option>
          </b-select>
        </form-group>

        <form-group
          horizontal
          name="is_sub_home"
          :label="$t('attributes.catalog_is_sub_home')"
        >
          <b-select v-model="form.is_sub_home" name="is_sub_home">
            <option value="true">{{ $t('attributes.display') }}</option>
            <option value="false">{{ $t('attributes.hide') }}</option>
          </b-select>
        </form-group>

        <form-group
          horizontal
          name="product_list_type"
          :label="
            $t('attributes.catalog_is_sub_home') +
              $t('attributes.product') +
              $t('attributes.display')
          "
        >
          <b-select v-model="form.product_list_type" name="product_list_type">
            <option value="0">
              {{ $t('attributes.product_type_graphic') }}
            </option>
            <option value="1">
              {{ $t('attributes.product_type_text') }}
            </option>
          </b-select>
        </form-group>

        <form-group
          horizontal
          name="is_show_products"
          :label="$t('attributes.is_show_products')"
        >
          <b-select v-model="form.is_show_products" name="is_show_products">
            <option value="true">{{ $t('attributes.display') }}</option>
            <option value="false">{{ $t('attributes.hide') }}</option>
          </b-select>
        </form-group>

        <form-group
          horizontal
          name="picture"
          attribute="attributes.catalog_cover"
          grouped
        >
          <template #label>
            {{ $t('attributes.catalog_cover') }}
            <b-tooltip type="is-danger" label="600*400/限定jpg檔，100KB內">
              <b-icon
                size="is-small"
                icon="help-circle-outline"
                type="is-danger"
              ></b-icon>
            </b-tooltip>
          </template>
          <b-field class="file">
            <a class="button is-primary" @click="onSelectCoverImage">
              <b-icon icon="upload"></b-icon>
              <span>{{ $t('message.please_select_file') }}</span>
            </a>
            <p
              v-if="form.picture"
              class="tag is-warning"
              style="margin-left: 4px; height: 40px"
            >
              <a
                :href="CatalogImage(form.picture)"
                @click.prevent="onClickImage(CatalogImage(form.picture))"
              >
                {{ form.picture }}
              </a>
            </p>
          </b-field>
        </form-group>

        <form-group
          horizontal
          name="operation_picture"
          attribute="attributes.operation_picture"
          grouped
        >
          <template #label>
            {{ $t('attributes.operation_picture') }}
            <b-tooltip type="is-danger" label="1920*400/限定jpg檔，600KB內">
              <b-icon
                size="is-small"
                icon="help-circle-outline"
                type="is-danger"
              ></b-icon>
            </b-tooltip>
          </template>
          <b-field class="file">
            <a class="button is-primary" @click="onSelectOperationPictureImage">
              <b-icon icon="upload"></b-icon>
              <span>{{ $t('message.please_select_file') }}</span>
            </a>
            <p
              v-if="form.operation_picture"
              class="tag is-warning"
              style="margin-left: 4px; height: 40px"
            >
              <a
                :href="CatalogImage(form.operation_picture)"
                @click.prevent="
                  onClickImage(CatalogImage(form.operation_picture))
                "
              >
                {{ form.operation_picture }}
              </a>
            </p>
          </b-field>
        </form-group>

        <form-group
          horizontal
          name="operation_mobile_picture"
          attribute="attributes.operation_mobile_picture"
          grouped
        >
          <template #label>
            {{ $t('attributes.operation_mobile_picture') }}
            <b-tooltip type="is-danger" label="600*400/限定jpg檔，100KB內">
              <b-icon
                size="is-small"
                icon="help-circle-outline"
                type="is-danger"
              ></b-icon>
            </b-tooltip>
          </template>
          <b-field class="file">
            <a
              class="button is-primary"
              @click="onSelectOperationMobilePictureImage"
            >
              <b-icon icon="upload"></b-icon>
              <span>{{ $t('message.please_select_file') }}</span>
            </a>
            <p
              v-if="form.operation_mobile_picture"
              class="tag is-warning"
              style="margin-left: 4px; height: 40px"
            >
              <a
                :href="CatalogImage(form.operation_mobile_picture)"
                @click.prevent="
                  onClickImage(CatalogImage(form.operation_mobile_picture))
                "
              >
                {{ form.operation_mobile_picture }}
              </a>
            </p>
          </b-field>
        </form-group>

        <b-field horizontal>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            style="width: 100%"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { AREA_API, CATALOG_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import {
  OpenCatalogCoverFinder,
  OpenCatalogOperationFinder
} from '@/utils/ckfinder'

export default {
  name: 'CatalogBasicForm',

  props: {
    catalog: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,
      loadingRegionList: false,

      form: this.extractFormValues(this.catalog),

      sortOptions: [...Array(50).keys()].map(i => i + 1),

      isImageModalActive: false,
      selectedImageUrl: null,
      regionList: []
    }
  },
  validations: {
    form: {
      sort: { required },
      status: { required },
      name: { required, maxLength: maxLength(30) },
      description: { maxLength: maxLength(500) },
      email: { maxLength: maxLength(100) },
      link: { maxLength: maxLength(500) },
      is_home: { required },
      is_sub_home: { required },
      picture: {},
      operation_picture: {},
      operation_mobile_picture: {},
      product_list_type: { required },
      is_show_products: { required },
      region_list_no: {},
      area_code: { required }
    }
  },
  watch: {
    catalog(newCatalog) {
      this.form = this.extractFormValues(newCatalog)
    }
  },
  mounted() {
    this.loadRegionList()
  },
  methods: {
    extractFormValues(data) {
      return {
        sort: data.sort,
        status: data.status,
        name: data.name,
        description: data.description,
        email: data.email,
        pop_url: data.pop_url,
        link: data.link,
        is_home: data.is_home,
        is_sub_home: data.is_sub_home,
        picture: data.picture,
        operation_picture: data.operation_picture,
        operation_mobile_picture: data.operation_mobile_picture,
        product_list_type: data.product_list_type,
        is_show_products: data.is_show_products,
        region_list_no: data.region_list_no,
        area_code: data.area_code
      }
    },
    async loadRegionList() {
      try {
        this.loadingRegionList = true
        const api = `${AREA_API}/${this.form.area_code}/region/list`
        const res = await this.axios.get(api)
        this.regionList = res.data.data
      } catch (e) {
        this.regionList = []
        notifyService.fetch_error('region', e)
      } finally {
        this.loadingRegionList = false
      }
    },
    async onSelectCoverImage() {
      try {
        this.form.picture = await OpenCatalogCoverFinder(
          this.catalog.image_path
        )
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSelectOperationPictureImage() {
      try {
        this.form.operation_picture = await OpenCatalogOperationFinder(
          this.catalog.image_path
        )
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSelectOperationMobilePictureImage() {
      try {
        this.form.operation_mobile_picture = await OpenCatalogOperationFinder(
          this.catalog.image_path,
          true
        )
      } catch (e) {
        notifyService.error(e)
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      try {
        this.sending = true

        const api = `${CATALOG_API}/${this.catalog.catalog_no}/basic`
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
